import React from 'react';
import ALink from "./ALink";
import useTranslation from "../../utils/hooks/useTranslation";
import {connect} from "react-redux";
import {solutions} from "../../utils/data/solutions";
import {categoryParam} from "../../utils/slugs";

function Footer ({categories, partners}) {
    const { t } = useTranslation();
    const getYear = () => {
        const date = new Date();
        return date.getFullYear();
    }

    return (
        <footer className="footer bg-dark">
            <div className="footer-middle">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-sm-6">
                            <div className="widget">
                                <h3 className="widget-title h4">{t("message.contact_info")}</h3>
                                <ul className="contact-info">
                                    <li>
                                        <span className="contact-info-label">{t("label.address")}:</span>Rruga e Kavajes, Blloku i banesave Park Construction Albania, Tirane
                                    </li>
                                    <li>
                                        <span className="contact-info-label">{t("label.phone")}:</span><ALink href="tel:">(+355) 69 60 22 333</ALink>
                                    </li>
                                    <li>
                                        <span className="contact-info-label">{t("label.email")}:</span>
                                        <ALink href="mailto:sales@ssd.al">sales@ssd.al</ALink>
                                    </li>
                                    <li>
                                        <span className="contact-info-label">{t("message.working_days_hours")}:</span>
                                        {t("message.open_hours")}
									</li>
                                </ul>
                                <div className="social-icons">
                                    <a href="https://www.facebook.com/dahua.al" target={"_blank"} rel={"noopener noreferrer"}
                                       className="social-icon social-facebook icon-facebook"
                                       title="Facebook"></a>
                                    <a href="https://www.instagram.com/ssd_albania/" target={"_blank"} rel={"noopener noreferrer"}
                                       className="social-icon social-instagram icon-instagram"
                                       title="Instagram"></a>
                                    <a href="https://www.youtube.com/channel/UC2bsk0iXdhTuiPcneqzYdYw" target={"_blank"} rel={"noopener noreferrer"}
                                       className="social-icon social-youtube fab fa-youtube"
                                       title="Youtube"></a>
                                    <a href="https://www.linkedin.com/company/ssd-albania/" target={"_blank"} rel={"noopener noreferrer"}
                                       className="social-icon social-linkedin fab fa-linkedin"
                                       title="Linkedin"></a>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-2 col-sm-6 widget-list">
                            <div className="widget">
                                <h3 className="widget-title h4">{t("label.products")}</h3>

                                <ul className="links">
                                    {categories.list?.map((category) =>
                                        <li key={"category-" + category.id}><ALink href={`/shop?category=${categoryParam(category)}`}>{category.name}</ALink></li>
                                    )}
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-2 col-sm-6 widget-list">
                            <div className="widget">
                                <h3 className="widget-title h4">{t("label.partners")}</h3>

                                <ul className={"links"}>
                                    {partners.list?.map((partner) => (
                                        <li key={"partner-" + partner.id}><a target={"_blank"} rel={"noopener noreferrer"} href={partner.url}>{partner.name}</a></li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-2 col-sm-6 widget-list">
                            <div className="widget">
                                <h3 className="widget-title h4">{t("label.solutions")}</h3>

                                <ul className={"links"}>
                                    {solutions.map((solution) => (
                                        <li key={"solution-" + solution.id}><ALink href={`/solutions/${solution.list[0].slug}`}>{t(solution.title)}</ALink></li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-2 col-sm-6 widget-list">
                            <div className="widget">
                                <h3 className="widget-title h4">{t("message.about_us")}</h3>

                                <ul className={"links"}>
                                    <li><ALink href={`/about-us/#summary`}>{t("label.summary")}</ALink></li>
                                    <li><ALink href={`/about-us/#our-mission`}>{t("message.our_mission")}</ALink></li>
                                    <li><ALink href={`/about-us/#vision`}>{t("label.vision")}</ALink></li>
                                    <li><ALink href={`/about-us/#long-term-goals`}>{t("message.long_term_goals")}</ALink></li>
                                    <li><ALink href={`/about-us/#rules`}>{t("message.ssd_rules")}</ALink></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="footer-bottom">
                    <div className="container d-sm-flex align-items-center">
                        <div className="footer-left">
                            <span className="footer-copyright">© SSD - Security Solution & Distribution! {getYear()}. {t("message.all_rights_reserved")}</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

const mapStateToProps = ( state ) => {
    return {
        categories: state.categories,
        partners: state.partners
    }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(Footer));